/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { RecurrenceRequestFreq } from './recurrenceRequestFreq';
import type { RecurrenceRequestUntil } from './recurrenceRequestUntil';
import type { RecurrenceRequestCount } from './recurrenceRequestCount';

/**
 * Recurrence pattern supplied by the client.

Inherits validation & descriptions from the shared model. No defaults are
added here; clients must provide values explicitly where required.
 */
export interface RecurrenceRequest {
  /** Recurrence frequency */
  freq: RecurrenceRequestFreq;
  /**
   * Number of weeks or months between occurrences
   * @minimum 1
   * @maximum 12
   */
  interval: number;
  /** Days of week for WEEKLY frequency (e.g., ['MO', 'WE', 'FR']) */
  byDay?: string[];
  /** Inclusive end date of the recurrence pattern (RFC-5545 UNTIL) */
  until?: RecurrenceRequestUntil;
  /** Number of occurrences (alternative to until) */
  count?: RecurrenceRequestCount;
}
